export default "__VITE_ASSET__db9ecc35__"